// Street autocomplete component for vue. Depends on vue-simple-suggest library.
require("custom-event-polyfill");

import Vue from "vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'

// Internal
class Addr {
    // <postalCode> <postOffice>
    option_value: string;
    postal: string;
    postalCode: string;
    postOffice: string;
    locale: string
    constructor(postalCode: string, postOffice: string, locale: string) {

        this.option_value = postalCode + locale ?? "";
        this.postalCode = postalCode;
        this.postOffice = postOffice;
        this.postal = postalCode + " " + postOffice;
        this.locale = locale;
    }
}

@Component({
    components: {
        VueSimpleSuggest
    }
})

export default class PostalAutocomplete extends Vue {
    
    @Prop({ required: true })
    value: string;
    @Prop()
    place: string;

    @Prop()
    streetLocale: string;

    @Prop({ default: false })
    disabled: boolean;

    @Watch("value")
    valueChanged(newValue: string) {
        this.query = newValue;
    }

    private query = "";
    private office = "";
    selectedItem: Addr = new Addr("", "", "");
    selectedLocale: string;

    autoCompleteStyle = {
        vueSimpleSuggest: "position-relative",
        inputWrapper: "",
        defaultInput: "form-control",
        suggestions: "position-absolute list-group z-1000",
        suggestItem: "list-group-item"
    }

    @Emit()
    postalCodeSelected(_postalCode: string, _locale: string) {
    }

    @Emit()
    postOfficeSelected(_postalOffice: string) {
    }

    mounted() {
        this.query = this.value;
        this.office = this.place;
    }
    
    searchForPostalCodes(query: string): Promise<Addr[]> | Addr[] {        
        return new Promise<Addr[]>((resolve, reject) => {
            const hub = $.connection.commonHub.server;
            const locale = this.streetLocale;
            hub.searchZipCode(query, locale).done(function (data) {
                const addrs = [];
                for (let i = 0; i < data.length; ++i) {
                    const searchItem = data[i];
                    addrs.push(new Addr(searchItem.Item1, searchItem.Item2, searchItem.Item3));
                }
                resolve(addrs);
            });
        });
    }

    onBlur() {
        // this makes sure that postal code is emitted even when no item is selected
        if (this.query == null || this.query == "") {
            this.selectedLocale = null;
        }
        this.postalCodeSelected(this.query, this.selectedLocale);
        // post office is set to null if item isn't selected from the list
        //this.postOfficeSelected(this.office);
    }

    onFocus() {
        if (this.selectedItem) {
            this.selectedItem.postal = `${this.selectedItem.postalCode} ${this.selectedItem.postOffice}`;
        }
    }

    //itemSelected(item: string | Addr) {
    itemSelected(selected: Addr) {
        let postalCode = "";
        let postOffice = "";
        let locale = null;
        if (!selected) {
            postalCode = this.query;
            // When re-opening the modal, post office would set to an empty string, and thus the post office would be removed from the contract process.
            // This hack is to prevent removing selected office when initially loading modal with existing data.
            postOffice = this.office;
            this.office = "";
        }
        else {
            postalCode = selected.postalCode;
            postOffice = selected.postOffice;
            locale = selected.locale;
            // query is the string which user has typed so it might be something
            // like 701 so we need to autocomplete it with the selected value to
            // make sure that onBlur doesn't emit wrong value
            this.query = postalCode;
            this.office = postOffice;
            // change postal to be same as postalCode. without this the field
            // content would be "70100 KUOPIO" not "70100"
            this.selectedItem.postal = postalCode;
            this.selectedItem.locale = locale;
        }
        this.selectedLocale = locale;
        this.postalCodeSelected(postalCode, locale);
        this.postOfficeSelected(postOffice);
    }
}